export const getNiederoesterreichData = () => ({
  name: "Niederösterreich",
  country: "Autriche",
  description: "Niederösterreich (Basse-Autriche) est la plus grande région viticole d'Autriche, réputée pour ses vins blancs élégants et ses vins rouges de qualité. Cette région bénéficie d'un climat continental avec des influences alpines, créant des conditions idéales pour la viticulture.",
  type: "region",
  area: "28,000 ha",
  production: "1.6 million hectolitres",
  climate: "Climat continental avec influences alpines, étés chauds et hivers froids",
  soil: "Sols calcaires, argileux, granitiques, excellente diversité géologique",
  characteristics: {
    climate: "Climat continental avec influences alpines, étés chauds et hivers froids",
    soil: "Sols calcaires, argileux, granitiques, excellente diversité géologique",
    viticulture: "Viticulture traditionnelle, rendements limités, qualité privilégiée"
  },
  wineStyles: {
    white: "Vins blancs secs et aromatiques, avec une acidité vive et des notes minérales",
    red: "Vins rouges élégants et structurés, avec des tanins fins",
    rosé: "Rosés délicats et fruités, parfaits pour l'apéritif",
    sweet: "Vins liquoreux exceptionnels"
  },
  history: "La viticulture à Niederösterreich remonte à l'époque romaine. Au Moyen Âge, les moines ont développé les techniques viticoles. La région a une tradition viticole millénaire, avec des cépages autochtones comme le Grüner Veltliner. Aujourd'hui, Niederösterreich est reconnue pour ses vins blancs de qualité.",
  foodPairing: "Cuisine autrichienne traditionnelle, poissons, fromages affinés, plats locaux",
  subregions: {
    "Wachau": {
      name: "Wachau",
      description: "Vallée viticole prestigieuse, spécialisée dans les vins blancs de qualité",
      area: "1,350 ha",
      characteristics: "Sols granitiques, climat continental, vins élégants",
      grapeVarieties: ["gruner-veltliner", "riesling", "chardonnay", "sauvignon-blanc"]
    },
    "Kremstal": {
      name: "Kremstal",
      description: "Région viticole produisant des vins rouges et blancs de qualité",
      area: "2,200 ha",
      characteristics: "Sols calcaires, climat tempéré, vins équilibrés",
      grapeVarieties: ["gruner-veltliner", "riesling", "zweigelt", "pinot-noir"]
    },
    "Kamptal": {
      name: "Kamptal",
      description: "Vallée viticole avec des vignobles établis",
      area: "3,800 ha",
      characteristics: "Sols argileux, microclimats, vins aromatiques",
      grapeVarieties: ["gruner-veltliner", "riesling", "chardonnay", "sauvignon-blanc"]
    }
  },
  grapeVarieties: [
    {
      name: "Grüner Veltliner",
      percentage: "45%",
      description: "Cépage emblématique d'Autriche, produisant des vins blancs secs et aromatiques",
      characteristics: "Sec, aromatique, acidité vive",
      wineStyles: "Sec, léger, aromatique"
    },
    {
      name: "Riesling",
      percentage: "25%",
      description: "Cépage blanc produisant des vins secs et minéraux",
      characteristics: "Sec, minéral, acidité vive",
      wineStyles: "Sec, moyen-corps, complexe"
    },
    {
      name: "Zweigelt",
      percentage: "15%",
      description: "Cépage rouge principal, produisant des vins élégants",
      characteristics: "Élégant, tanins fins, fruits rouges",
      wineStyles: "Sec, moyen-corps, fruité"
    },
    {
      name: "Chardonnay",
      percentage: "10%",
      description: "Cépage blanc produisant des vins secs et équilibrés",
      characteristics: "Sec, équilibré, notes de fruits blancs",
      wineStyles: "Sec, moyen-corps, complexe"
    },
    {
      name: "Autres",
      percentage: "5%",
      description: "Autres cépages incluant Sauvignon Blanc, Pinot Noir et cépages autochtones",
      characteristics: "Diversifiés, expérimentaux",
      wineStyles: "Variés selon le cépage"
    }
  ],
  mapAreas: [
    { region: "Wachau", x: 16.0, y: 48.5, color: "#4B164C", size: 5 },
    { region: "Kremstal", x: 16.2, y: 48.4, color: "#6d2c7a", size: 4 },
    { region: "Kamptal", x: 15.8, y: 48.6, color: "#8a4a8a", size: 4 }
  ]
}); 